import { Badge, type BadgeProps } from "@/components/ui/badge"
import type { EnquiryPipeline, EnquiryStatus } from "@/types/inertia"

// Status and pipeline badges for the admin (M7). Every badge carries its
// label as text, so the tone is never the only signal.

type Tone = NonNullable<BadgeProps["tone"]>

const STATUS_TONES: Record<EnquiryStatus, Tone> = {
  received: "signal", // new in: needs a first look
  in_design: "neutral",
  approved: "accent",
  in_production: "solid",
  delivered: "muted",
}

const PIPELINE_TONES: Record<EnquiryPipeline, Tone> = {
  open: "neutral",
  won: "accent",
  lost: "muted",
}

/** The customer-visible step ("In production"). */
export function StatusBadge({ status, label }: { status: EnquiryStatus; label: string }) {
  return <Badge tone={STATUS_TONES[status]}>{label}</Badge>
}

/** Duncan's own won / lost / open, never shown to the customer. */
export function PipelineBadge({ pipeline, label }: { pipeline: EnquiryPipeline; label: string }) {
  return <Badge tone={PIPELINE_TONES[pipeline]}>{label}</Badge>
}
